import type { AxiosRequestConfig, GenericAbortSignal } from 'axios'
import { API_VACANCY_URL } from '../constants/base-urls'
import type { IPaginationParam, IPaginationResponse, IStatistic, IVacancy } from '../types'
import { createAxiosInstance } from '../utils'

type FetchVacanciesParams = {
  departmentIds?: string
  isRequisition?: 0 | 1
  status?: string
} & IPaginationParam

const axios = createAxiosInstance({
  baseURL: API_VACANCY_URL,
  withAuth: true,
})

export const fetchVacancies = (params?: FetchVacanciesParams, signal?: GenericAbortSignal) => {
  return axios.get<{ data: IPaginationResponse<IVacancy> }>(`/vacancy`, { params, signal }).then((response) => response.data.data)
}

export const fetchVacancyDetail = (id: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: IVacancy }>(`/vacancy/${id}`, config).then((response) => response.data.data)
}

export const createVacancy = (payload: Record<string, any>) => {
  return axios.post<{ data: IVacancy }>(`/vacancy`, payload).then((response) => response.data.data)
}

export const udpateVacancy = (id: string, payload: Record<string, any>) => {
  return axios.put<{ data: IVacancy }>(`/vacancy/${id}`, payload).then((response) => response.data.data)
}

export const deleteDraftVacancy = (id: string) => {
  return axios.delete(`/vacancy/${id}`).then((response) => response.data.data)
}

export const updateVacancyStatus = (id: string, status: 'active' | 'draft' | 'inactive', payload?: Record<string, any>) => {
  return axios.patch(`/vacancy/${id}`, { ...payload, status }).then((response) => response.data.data)
}

export const updateRequisitionStatus = (
  id: string,
  status: 'reject' | 'approve' | 'cancel' | 'publish' | 'progress',
  payload?: Record<string, any>,
  config?: AxiosRequestConfig,
) => {
  return axios.patch(`/requisition/${id}`, { approvalId: '', notes: '', ...payload, status }, config).then((response) => response.data.data)
}

export const sendReminder = (id: string) => {
  return axios.post(`/requisition/${id}/send-reminder`).then((response) => response.data.data)
}

export const fetchVacancyStratistic = (params?: { isRequisition: '1' | '0' }) => {
  return axios.get<{ data: IStatistic[] }>(`/statistics`, { params }).then((response) => response.data.data)
}

export const fetchVacancyRRNumber = () => {
  return axios.get<{ data: { rrNumber: string } }>(`/requisition/rr-number`).then((response) => response.data.data)
}
